import { CoverageRecommendation, Rubric } from "./types";

export type RatingLevel = {
  value: Rubric;
  label: string;
  activeClass: string;
  chipClass: string;
  dotClass: string;
  strokeClass: string;
};

export const RATING_LEVELS: RatingLevel[] = [
  {
    value: 1,
    label: "Poor",
    activeClass: "bg-danger/15 text-danger",
    chipClass:
      "inline-flex h-6 items-center gap-1.5 rounded-lg border border-danger/40 bg-danger/15 px-2 text-xs font-semibold text-danger",
    dotClass: "bg-danger",
    strokeClass: "stroke-danger",
  },
  {
    value: 2,
    label: "Fair",
    activeClass: "bg-warning/15 text-warning",
    chipClass:
      "inline-flex h-6 items-center gap-1.5 rounded-lg border border-warning/40 bg-warning/15 px-2 text-xs font-semibold text-warning",
    dotClass: "bg-warning",
    strokeClass: "stroke-warning",
  },
  {
    value: 3,
    label: "Good",
    activeClass: "bg-info/15 text-info",
    chipClass:
      "inline-flex h-6 items-center gap-1.5 rounded-lg border border-info/40 bg-info/15 px-2 text-xs font-semibold text-info",
    dotClass: "bg-info",
    strokeClass: "stroke-info",
  },
  {
    value: 4,
    label: "Excellent",
    activeClass: "bg-success/15 text-success",
    chipClass:
      "inline-flex h-6 items-center gap-1.5 rounded-lg border border-success/40 bg-success/15 px-2 text-xs font-semibold text-success",
    dotClass: "bg-success",
    strokeClass: "stroke-success",
  },
];

export const getRatingLevel = (value?: number | null): RatingLevel | null =>
  RATING_LEVELS.find((level) => level.value === value) ?? null;

export const getRubricVerdict = (average?: number | null): RatingLevel | null =>
  average === null || average === undefined ? null : getRatingLevel(Math.round(average));

export const COVERAGE_CHIP_CLASSNAME =
  "inline-flex h-7 items-center gap-1.5 rounded-xl border card-border bg-primary/5 px-2.5 text-xs font-medium text-foreground";

export const COVERAGE_VERDICT_CHIP_CLASSNAME: Record<CoverageRecommendation, string> = {
  pass: "inline-flex h-7 items-center gap-1 rounded-xl border border-border bg-muted/60 px-2.5 text-xs font-semibold text-muted-foreground",
  consider:
    "inline-flex h-7 items-center gap-1 rounded-xl border border-primary/40 bg-primary/15 px-2.5 text-xs font-semibold text-primary",
  recommend:
    "inline-flex h-7 items-center gap-1 rounded-xl border border-success/40 bg-success/15 px-2.5 text-xs font-semibold text-success",
};
